import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders, HttpResponse } from "@angular/common/http";
import { environment } from "src/environments/environment.prod";
// import { Observable } from 'rxjs/Observable';

@Injectable({
  providedIn: "root",
})
export class FeedbackService {
  constructor(private http: HttpClient) { }

  sendFeedback(feedback: any) {
    console.log("this.FeedbackData", feedback);
    let headers = new HttpHeaders();
    headers.append("Content-type", "application/json");
    headers.append("Accept", "application/json");
    headers.append("Access-Control-Allow-Origin", "*");
    //console.log('Getting token kashfashkfg', this.userToken, 'jsdhgfhkauibgfjuafi', addCity.cityName);
    // return this.http.post(environment.API_STARTPOINT + "feedback", feedback, {
    return this.http.post(environment.API_STARTPOINT + "sendMail", feedback, {
      headers: headers,
    });
  }
}
